// One side of a machine's (or a material's) sheet as the cards write it: in inches to two places for an inch user
// and whole millimetres otherwise.
export const machineDimensionText = (valueMm) => (
  window.user_unit == 'in'
    ? `${(parseFloat(valueMm) / 25.4).toFixed(2)}in`
    : `${Math.round(parseFloat(valueMm))}mm`
);

// The whole sheet, the vertical side first, matching the standard boards (e.g. "560mm X 770mm").
const machineSheetText = (widthMm, heightMm) => `${machineDimensionText(heightMm)} X ${machineDimensionText(widthMm)}`;

export default machineSheetText;
